import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TagManager from "../../TagManager";
import {t} from "../../Translations";
import StepSubTitle from "../widgets/StepSubTitle";
import IncrementalInput from "../widgets/IncrementalInput";

import City from '../icons/City';
import Road from '../icons/Road';
import Highway from '../icons/Highway';

class Step2_3 extends React.Component {

    static propTypes = {
        className: PropTypes.string,

        // Triggered when step data change
        onDataChange: PropTypes.func,

        // Used to initialize step data
        data: PropTypes.shape({
            mixCity: PropTypes.number,
            mixRoad: PropTypes.number,
            mixMotorway: PropTypes.number
        })
    };

    static defaultProps = {
        data: {
            mixCity: undefined,
            mixRoad: undefined,
            mixMotorway: undefined
        }
    };

    componentDidMount() {
        const {data, vehicleDetail} = this.props

        TagManager.sendEvent(
            '/consommation/form/estimation-precise-usage/step-3',
            'form page',
            null,
            'consommation estimation precise',
            3,
            'parcours',
            data.bodyStyle,
            `${vehicleDetail.model} ${vehicleDetail.bodyStyle} ${vehicleDetail.commercialName} ${vehicleDetail.engine}`
        )
    }

    render() {
        const {className, data, onDataChange} = this.props;

        const classes = classNames(
            "container-form-step2",
            "p-4",
            "distance-container",
            {
                [className]: className !== undefined
            }
        );

        return (
            <section className={classes}>
                <StepSubTitle className="my-2">
                    {t('Step2_route_label')}
                </StepSubTitle>

                <div className="row text-center">
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="icon-container">
                            <City/>
                        </div>

                        <IncrementalInput
                            label={t('Step2_route_question_1')}
                            value={data.mixCity}
                            step={10}
                            min={0}
                            max={100}
                            rowTwo={1}
                            symbol=" %"
                            onChange={onDataChange('mixCity')}
                        />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="icon-container">
                            <Road/>
                        </div>

                        <IncrementalInput
                            label={t('Step2_route_question2')}
                            value={data.mixRoad}
                            step={10}
                            min={0}
                            max={100}
                            rowTwo={1}
                            symbol=" %"
                            onChange={onDataChange('mixRoad')}
                        />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="icon-container">
                            <Highway/>
                        </div>

                        <IncrementalInput
                            label={t('Step2_route_question3')}
                            value={data.mixMotorway}
                            step={10}
                            min={0}
                            max={100}
                            rowTwo={1}
                            symbol=" %"
                            onChange={onDataChange('mixMotorway')}
                        />
                    </div>
                </div>
            </section>
        )
    }
}

export default Step2_3;


// WEBPACK FOOTER //
// ./src/components/steps/Step2_3.js